import React from 'react';
import './Menu.css';

export function Menu({active, toggle}) {
	return <div className={"menu " + (active ? "active" : undefined)} onClick={toggle}>
		<div className="bar1"><div className="seg1"></div><div className="seg2"></div></div>
		<div className="bar2"><div className="seg1"></div><div className="seg2"></div></div>
		<div className="bar3"><div className="seg1"></div><div className="seg2"></div></div>
	</div>
}